import * as React from 'react';
import { createContext } from 'react';
import { IExternalNodeProps, ITreeData } from './types';

interface ITreeContext {
    data: ITreeData[];
    node?: React.FC<IExternalNodeProps>;
    onSelect: (item: ITreeData) => void;
}

export const TreeContext = createContext<ITreeContext>({
    data: [],
    onSelect: () => {
        /*  */
    },
});

export const useTreeContext = () => React.useContext(TreeContext);
